import './polyfills'; // en başta: prerender/legacy built-in polyfill'leri
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './utils/i18n';
import './utils/vitals'; // Core Web Vitals → GA4

const container = document.getElementById('root');

if (container.hasChildNodes()) {
  hydrateRoot(container, <App />);
} else {
  createRoot(container).render(<App />);
} 